import React from 'react';
import TreeItem from '@mui/lab/TreeItem';

import { extractProperty } from '@utils';
import { DescriptionsTypeTree } from '../models';
import { ColumnTreeItem } from './column-tree-item';
import { TreeItemLabel } from './tree-item-label';

export const TypeTreeItem: React.FC<{
  type: DescriptionsTypeTree;
}> = ({ type }) => {
  return type.columns.length === 1 ? (
    <ColumnTreeItem column={type.columns[0]} />
  ) : (
    <TreeItem
      nodeId={type.nodeId}
      classes={{
        focused: 'tree-item-focused',
        selected: 'tree-item-focused',
      }}
      label={
        <TreeItemLabel
          label={type.summary}
          nodeId={type.nodeId}
          managedDescriptions={type.columns.flatMap(
            extractProperty('descriptions')
          )}
        />
      }
    >
      {type.columns.map((column, idx) => (
        <ColumnTreeItem key={column.nodeId} column={column} />
      ))}
    </TreeItem>
  );
};
